import { useMemo } from 'react'; 
import { useLazyQuery } from '@apollo/client';
import DATA_WAREHOUSE_EXPORT from '../queries/DATA_WAREHOUSE_EXPORT';
import { getFormattedDate } from '../../utils';

const useDataWarehouseExport = () => { 
    const [ fetchExport, { data, loading, error } ] = useLazyQuery( DATA_WAREHOUSE_EXPORT );

    const exportData = useMemo( () => {
        if ( !data || !data.dataWarehouseExport?.node ) { return; }
    
        return {
            ...data.dataWarehouseExport.node,
            key: data.dataWarehouseExport.node.id || '',
            createdAt: getFormattedDate( data.dataWarehouseExport.node.createdAt ),
            startedAt: getFormattedDate( data.dataWarehouseExport.node.startedAt ),
            completedAt: getFormattedDate( data.dataWarehouseExport.node.startedAt ),
            updatedAt: getFormattedDate( data.dataWarehouseExport.node.updatedAt )
        }; 
    }, [ data ] );
    
    const loadExport = ( dataWarehouseExportId ) => {
        const vars = {
            variables: {
                dataWarehouseExportId: dataWarehouseExportId
            }, 
            fetchPolicy: 'network-only' 
        };

        return fetchExport( vars );
    };
   
    return useMemo( () => {
        return {
            loadExport,
            exportData: exportData,
            exportError: error,
            exportLoading: loading, 
        };
    }, [ exportData, error, loading ] );
};

export default useDataWarehouseExport;
